const scenarioTitles = {
  "Scenario 1": "Scenario One",
  "Scenario 2": "Scenario Two",
  "Scenario 3": "Scenario Three",
  "Scenario 4": "Scenario Four",
  "mitigation_cap21_a33e61_1": "A33-E61",
  "mitigation_a33e61_1_halfled-hire": "A33-E61 - halfled-hire",
  "mitigation_cap21_a33e61_1_hiprice": "A33-E61 - hiprice",
  "mitigation_cap21_a33e61_1_hiprice_led": "A33-E61 - hiprice-led",
  "mitigation_cap21_a33e61_1_vhing_hire_halfled":
    "A33-E61 - vhing-hire-halfled",
  "mitigation_cap21_a33e61_1-halfled": "A33-E61 - halfled",
  "mitigation_cap21_a33e61_1-halfled-hire-hiprice":
    "A33-E61 - halfled-hire-hiprice",
  "mitigation_cap21_a33e61_1-hiprice": "A33-E61 - hiprice",
  "mitigation_cap21_a33e61_1-hiprice-halfled": "A33-E61 - hiprice-halfled",
  "mitigation_cap21_a33e61_1-hire": "A33-E61 - hire",
  "mitigation_cap21_a33e61_1-hire-hiprice": "A33-E61 - hire-hiprice",
  "no_mitigation_1_hiprice": "No Mitigation - hiprice",
  "no_mitigation": "No Mitigation",
  "Mitigation_CAP21_A25E65": "A25-E65",
  "Mitigation_CAP21_A25E65-BioImp": "A25-E65 Bio Import",
  "Mitigation_CAP21_A25E65-EA": "A25-E65 Early Action",
  "Mitigation_CAP21_A25E65-H2Imp": "A25-E65 H2 Import",
  "Mitigation_CAP21_A25E65-LA": "A25-E65 Late Action",
  "Mitigation_CAP21_A25E65-LED": "A25-E65 LED",
  "Mitigation_CAP21_A25E65-LED-techOptimism": "A25-E65 LED Tech-Optimism",
  "Mitigation_CAP21_A25E65-earlyCCS": "A25-E65 Early CCS",
  "Mitigation_CAP21_A25E65-highREN": "A25-E65 High REN",
  "Mitigation_CAP21_A25E65-lowBio": "A25-E65 Low Bio",
  "Mitigation_CAP21_A25E65-techOptimism": "A25-E65 Tech-Optimism",
  "Mitigation_CAP21_A33E61": "A33-E61",
  "Mitigation_CAP21_A33E61-BioImp": "A33-E61 Bio Import",
  "Mitigation_CAP21_A33E61-EA": "A33-E61 Early Action",
  "Mitigation_CAP21_A33E61-H2Imp": "A33-E61 H2 Import",
  "Mitigation_CAP21_A33E61-LA": "A33-E61 Late Action",
  "Mitigation_CAP21_A33E61-LED": "A33-E61 LED",
  "Mitigation_CAP21_A33E61-LED-techOptimism": "A33-E61 LED Tech-Optimism",
  "Mitigation_CAP21_A33E61-earlyCCS": "A33-E61 Early CCS",
  "Mitigation_CAP21_A33E61-highREN": "A33-E61 High REN",
  "Mitigation_CAP21_A33E61-lowBio": "A33-E61 Low Bio",
  "Mitigation_CAP21_A33E61-techOptimism": "A33-E61 Tech-Optimism",
  "Mitigation_CAP21_A40E57": "A40-E57",
  "Mitigation_CAP21_A40E57-BioImp": "A40-E57 Bio Import",
  "Mitigation_CAP21_A40E57-EA": "A40-E57 Early Action",
  "Mitigation_CAP21_A40E57-H2Imp": "A40-E57 H2 Import",
  "Mitigation_CAP21_A40E57-LA": "A40-E57 Late Action",
  "Mitigation_CAP21_A40E57-LED": "A40-E57 LED",
  "Mitigation_CAP21_A40E57-LED-techOptimism": "A40-E57 LED Tech-Optimism",
  "Mitigation_CAP21_A40E57-earlyCCS": "A40-E57 Early CCS",
  "Mitigation_CAP21_A40E57-highREN": "A40-E57 High REN",
  "Mitigation_CAP21_A40E57-lowBio": "A40-E57 Low Bio",
  "Mitigation_CAP21_A40E57-techOptimism": "A40-E57 Tech-Optimism",
  "Mitigation_CAP21_A51E51": "A51-E51",
  "Mitigation_CAP21_A51E51-BioImp": "A51-E51 Bio Import",
  "Mitigation_CAP21_A51E51-EA": "A51-E51 Early Action",
  "Mitigation_CAP21_A51E51-H2Imp": "A51-E51 H2 Import",
  "Mitigation_CAP21_A51E51-LA": "A51-E51 Late Action",
  "Mitigation_CAP21_A51E51-LED": "A51-E51 LED",
  "Mitigation_CAP21_A51E51-LED-techOptimism": "A51-E51 LED Tech-Optimism",
  "Mitigation_CAP21_A51E51-earlyCCS": "A51-E51 Early CCS",
  "Mitigation_CAP21_A51E51-highREN": "A51-E51 High REN",
  "Mitigation_CAP21_A51E51-lowBio": "A51-E51 Low Bio",
  "Mitigation_CAP21_A51E51-techOptimism": "A51-E51 Tech-Optimism",
  "Mitigation_CAP21_A55E49": "A55-E49",
  "Mitigation_CAP21_A55E49-BioImp": "A55-E49 Bio Import",
  "Mitigation_CAP21_A55E49-EA": "A55-E49 Early Action",
  "Mitigation_CAP21_A55E49-H2Imp": "A55-E49 H2 Import",
  "Mitigation_CAP21_A55E49-LA": "A55-E49 Late Action",
  "Mitigation_CAP21_A55E49-LED": "A55-E49 LED",
  "Mitigation_CAP21_A55E49-LED-techOptimism": "A55-E49 LED Tech-Optimism",
  "Mitigation_CAP21_A55E49-earlyCCS": "A55-E49 Early CCS",
  "Mitigation_CAP21_A55E49-highREN": "A55-E49 High REN",
  "Mitigation_CAP21_A55E49-lowBio": "A55-E49 Low Bio",
  "Mitigation_CAP21_A55E49-techOptimism": "A55-E49 Tech-Optimism",
  "Mitigation_WAM": "WAM",
  "No_Mitigation": "No Mitigation",
  "Mitigation_SectoralCBs": "Sectoral CBs",
  "Mitigation_ReducedSectoralCBs": "Reduced Sectoral CBs",
  "Mitigation_CarbonBudget": "Whole System CB",
  "Mitigation_ReducedCarbonBudget": "Reduced System CB",
  "Mitigation_SectoralCBs-TechOptimism": "Sectoral CBs (TO)",
  "Mitigation_ReducedSectoralCBs-TechOptimism": "Reduced Sectoral CBs (TO)",
  "Mitigation_CarbonBudget-TechOptimism": "Whole System CB (TO)",
  "Mitigation_ReducedCarbonBudget-TechOptimism": "Reduced System CB (TO)",
  "Mitigation_SectoralCBs-LED_Halfway": "Sectoral CBs (HL)",
  "Mitigation_ReducedSectoralCBs-LED_Halfway": "Reduced Sectoral CBs (HL)",
  "Mitigation_CarbonBudget-LED_Halfway": "Whole System CB (HL)",
  "Mitigation_ReducedCarbonBudget-LED_Halfway": "Reduced System CB (HL)",
  "Mitigation_SectoralCBs-LED_Halfway-TechOptimism": "Sectoral CBs (HL-TO)",
  "Mitigation_ReducedSectoralCBs-LED_Halfway-TechOptimism":
    "Reduced Sectoral CBs (HL-TO)",
  "Mitigation_CarbonBudget-LED_Halfway-TechOptimism": "Whole System CB (HL-TO)",
  "Mitigation_ReducedCarbonBudget-LED_Halfway-TechOptimism":
    "Reduced System CB (HL-TO)",
  "Mitigation_Baseline": "Baseline",
  "Mitigation_Electrification": "Electrification"
};

export default scenarioTitles;
